import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Office } from '@playbook/models';
import { OfficeState, OfficeStore } from './office.store';

@Injectable({ providedIn: 'root' })
export class OfficeQuery extends QueryEntity<OfficeState, Office, number> {
  constructor(protected store: OfficeStore) {
    super(store);
  }
}
